import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { useState, useEffect } from 'react';
import Feed from './pages/Feed';
import MomentPage from './pages/MomentPage';
import CollectionsPage from './pages/CollectionsPage';
import ProfilePage from './pages/ProfilePage';
import ResetPassword from './pages/ResetPassword';
import RoomPage from './pages/RoomPage';
import AboutPage from './pages/AboutPage';
import AppLoader from './components/AppLoader';
import './App.css';

// Must be INSIDE <BrowserRouter>
function AuthRedirectHandler() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('access_token')) {
      const params = new URLSearchParams(hash.replace('#', ''));
      if (params.get('type') === 'recovery') {
        navigate('/resetpassword', { state: { hash } });
      }
    }
  }, []);
  return null;
}

export default function App() {
  const [loading, setLoading] = useState(true);
  if (loading) return <AppLoader onFinish={() => setLoading(false)} />;

  return (
    <AppProvider>
      <BrowserRouter>
        <AuthRedirectHandler />
        <Routes>
          <Route path="/" element={<Feed />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/moment/:id" element={<MomentPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/profile/:username" element={<ProfilePage />} />
          <Route path="/collections/:id" element={<CollectionsPage />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/room/:roomId" element={<RoomPage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}